// extracted by mini-css-extract-plugin
export default {"autoDetectButton":"Ah81zWEe4z5xG7w0DMlo","autoDetectImage":"KPU6dwDDRBY9WrYspK1j","spinner":"ceaqDaqOXaSu_0BeK_1q","spin":"ePey0tinJ4SyInpcTSrX"};